import React from 'react';

import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import {getSecondaryText} from 'ui-library/chips/EntryChip';
import SmartChip from 'ui-library/chips/SmartChip';
import useSmartChipQuery, {SmartChipType} from 'ui-library/chips/useSmartChipQuery';

export interface FileChipProps extends SharedSmartChipProps<SmartChipType.FILE> {}

export default function FileChip(props: FileChipProps): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: file,
    handleClickLink,
    isInaccessible,
    itemUrl,
  } = useSmartChipQuery<SmartChipType.FILE>({
    id,
    onClick,
    getUrlFn: ({editUrl}) => editUrl,
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon="file"
      isInaccessible={isInaccessible}
      item={file}
      onClick={handleClickLink}
      url={itemUrl}
      getSecondaryText={getSecondaryText}
    />
  );
}
